<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M4 2H20C20.55 2 21.021 2.196 21.413 2.588C21.805 2.98 22.0007 3.45067 22 4V15C22 15.55 21.8043 16.021 21.413 16.413C21.0217 16.805 20.5507 17.0007 20 17H16V22L12 20L8 22V17H4C3.45 17 2.97933 16.8043 2.588 16.413C2.19667 16.0217 2.00067 15.5507 2 15V4C2 3.45 2.196 2.97933 2.588 2.588C2.98 2.19667 3.45067 2.00067 4 2ZM4 13H20V10H4V13Z"
      fill="currentColor"
    />
  </svg>
</template>
